module.exports = __webpack_public_path__ + "8945f710f4f355091b06ef5b5917d8e4.woff2";